import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

function SearchBox({ onChange, value }) {
  return (
    <div className="searchbox">
      <FontAwesomeIcon icon={faMagnifyingGlass} />
      <input
        type="text"
        placeholder="Search for a country..."
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default SearchBox;
